import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("enoteca_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);

export const B2B_VAT_RATE = 0.22;
// True se l'utente è un account azienda approvato
export const isApprovedCompany = (user) => user?.account_type === "company" && user?.company_status === "approved";
// Prezzo azienda IVA esclusa: prezzo lordo -> netto IVA -> sconto azienda
export const b2bNetPrice = (grossPrice, discountPercent = 0) => {
  const net = Number(grossPrice) / (1 + B2B_VAT_RATE);
  return net * (1 - (Number(discountPercent) || 0) / 100);
};

// Formatta una data ISO ('YYYY-MM-DD' o ISO completo) come 'DD-MM-YYYY'. Ritorna "" se assente/invalida.
export function formatDate(value) {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  const d = new Date(s);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}
